/* Inpatient screens: the bed board, the stay and the admit form (DESIGN.md §8 "Ward bed
 * board"). States are words plus shapes: occupied has an ink outline and the name, free an
 * empty hairline tile, cleaning a wash fill, blocked a hatch. Tokens only. */

.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.meta {
  margin: 0;
  color: var(--graphite);
  font: var(--t-small);
}

.counts {
  margin: 0;
  color: var(--graphite);
  font: var(--t-small);
  font-variant-numeric: tabular-nums;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(10.5rem, 1fr));
  gap: var(--space-3);
  margin: 0;
  padding: 0;
  list-style: none;
}

.bed {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  width: 100%;
  min-height: 6.5rem;
  padding: var(--space-3);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-control);
  background: var(--paper);
  color: var(--ink);
  font: var(--t-body);
  text-align: left;
  cursor: pointer;
  transition: background-color var(--dur) var(--ease);
}

.bed:hover {
  background-color: var(--brand-tint);
}

.bed:focus-visible {
  outline: var(--focus-ring);
  outline-offset: 2px;
}

/* States by outline and fill, and always the word (ADR 0028): occupied a solid primary edge,
   vacant a plain outline, cleaning a dashed amber edge on the amber tint (waiting), blocked
   a hatch. */
.bed[data-state='occupied'] {
  border: 2px solid var(--brand);
}

.bed[data-state='cleaning'] {
  border-style: dashed;
  border-color: var(--color-warning);
  background: var(--color-warning-tint);
}

.bed[data-state='cleaning'] .bedState {
  color: var(--color-warning-text);
}

.bed[data-state='blocked'] {
  background: repeating-linear-gradient(135deg, var(--wash) 0 6px, var(--paper) 6px 12px);
}

.bedLabel {
  font: var(--t-body-strong);
}

.bedState {
  color: var(--graphite);
  font: var(--t-small);
}

.bedName {
  font: var(--t-body);
  overflow-wrap: anywhere;
}

.bedDays {
  color: var(--graphite);
  font: var(--t-small);
  font-variant-numeric: tabular-nums;
}

/* A precaution in place (operations plan §2.1): an outlined word, passive, never danger. */
.precaution {
  align-self: flex-start;
  padding: 0 var(--space-1);
  border: 1px solid var(--ink);
  border-radius: var(--radius-tag);
  font: var(--t-small);
}

.waiting {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.waitingRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  min-height: 44px;
  padding: var(--space-2) 0;
  border-bottom: 1px solid var(--rule);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
}

.row > * {
  flex: 1 1 14rem;
  min-width: 0;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.facts {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: var(--space-2) var(--space-5);
  margin: 0;
}

.facts dt {
  color: var(--graphite);
  font: var(--t-small);
}

.facts dd {
  margin: 0;
  overflow-wrap: anywhere;
}

.prose {
  max-width: 75ch;
  margin: 0;
  white-space: pre-wrap;
  line-height: 1.55;
}

.money {
  font-variant-numeric: tabular-nums;
}
